<template>
  <ul v-if="autoCompleteItems && autoCompleteItems.length > 0">
    <AutoCompleteItem
      v-for="(item, index) in autoCompleteItems"
      :key="index"
      :autoCompleteItem="item"
      :index="index + 1"
      :query="query"
      :currentSelectionIndex="currentSelectionIndex"
      @currentSuggestion="currentSuggestion"
      @currentSuggestionItem="currentSuggestionItem"
    >
    </AutoCompleteItem>
  </ul>
</template>
<script>
import AutoCompleteItem from "./autocompleteitem.vue";
export default {
  name: "AutoCompleteResult",
  props: {
    autoCompleteItems: Array,
    query: String,
    currentSelectionIndex: Number,
  },
  components: {
    AutoCompleteItem,
  },
  emits: ["currentSuggestion", "currentSuggestionItem"],
  created() {},
  methods: {
    currentSuggestion(suggestion, click) {
      this.$emit("currentSuggestion", suggestion, click);
    },
    currentSuggestionItem(suggestionItem, click) {
      this.$emit("currentSuggestionItem", suggestionItem, click);
    },
  },
};
</script>
